import React, { PropTypes, PureComponent } from 'react'
import { connect } from 'react-redux'
import NotificationSystem from 'react-notification-system'
import { notify } from './NotifierActions'

class NotifierComponent extends PureComponent {

	system = () => (
		this.refs.notificationSystem
	)

	componentWillReceiveProps(nextProps) {
		const { notification } = nextProps.notifications
		if (notification) {
			this.system().addNotification(notification)
		}
	}

	render() {
		return (
			<div>
				<NotificationSystem ref="notificationSystem" noAnimation={false} style={false} />
			</div>
		)
	}
}

NotifierComponent.propTypes = {
	notifications: PropTypes.shape({
		children: PropTypes.string,
		level: PropTypes.string,
		position: PropTypes.string,
		autoDismiss: PropTypes.number,
		uid: PropTypes.string,
		onlineChanged: PropTypes.bool
	}),

	dispatchNotify: PropTypes.func
}

const mapStateToProps = state => ({
	notifications: state.notifications
})

const mapDispatchToProps = (dispatch) => (
	{
		dispatchNotify: (notification) => {
			dispatch(notify(notification))
		}
	}
)

export default connect(mapStateToProps, mapDispatchToProps)(NotifierComponent)



// WEBPACK FOOTER //
// ./src/components/notifier/NotifierComponent.js